module.exports = __webpack_public_path__ + "img/map-static.e9510e11.png";